import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTVideoInput from 'general/components/OtherKeenComponents/FileUpload/KTVideoInput';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import KTFormRichTextEditor from 'general/components/OtherKeenComponents/Forms/KTFormRichTextEditor';
import { useTranslation } from 'react-i18next';

DialogAddTutorialView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogAddTutorialView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const { t } = useTranslation();
    const editMode = !!item;
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [selectedObject, setSelectedObject] = useState('DRIVER');
    const [order, setOrder] = useState(null);
    const [title, setTitle] = useState(null);
    const [content, setContent] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videoSrc, setVideoSrc] = useState(null);

    useEffect(() => {
        if (item) {
            setSelectedObject(item?.for);
            setOrder(item?.order);
            setTitle(item?.title);
            setContent(item?.content);
            setVideoSrc(item?.videoUrl);
            setSelectedVideo(item?.videoUrl);
        }
    }, [item]);

    // MARK: ---- METHODS ----
    const handleUploadFile = async () => {
        if (!videoSrc) return '';

        if (videoSrc instanceof File) {
            const res = await miscHelper.callApiUploadFile(videoSrc);
            return res[0]?.relativePath || '';
        }

        return videoSrc;
    };

    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (!Utils.isValid(order) || !Utils.isValid(title) || !Utils.isValid(content) || !selectedObject || !videoSrc) {
            ToastHelper.showError('Bạn chưa nhập đủ thông tin');
            return;
        }
        if (Utils.isValid(order) && order <= 0) {
            ToastHelper.showError('Thứ tự xuất hiện phải lớn hơn 0');
            return;
        }
        setLoading(true);
        const videoPath = await handleUploadFile();
        let params = {
            for: selectedObject,
            title,
            content,
            videoUrl: videoPath,
            status: 'NORMAL',
            order,
        };
        if (editMode) {
            ChargeHelper.API.Tutorial.requestUpdateTutorial(item.tutorialId, params)
                .then((res) => {
                    ToastHelper.showSuccess('Cập nhật hướng dẫn sử dụng thành công');
                    if (onDone) onDone();
                })
                .catch((error) => {
                    ToastHelper.showError('Có lỗi xảy ra');
                })
                .finally(() => {
                    setLoading(false);
                });
            return;
        } else {
            ChargeHelper.API.Tutorial.requestCreateTutorial(params)
                .then((res) => {
                    ToastHelper.showSuccess('Thêm hướng dẫn sử dụng thành công');
                    if (onDone) onDone();
                })
                .catch((error) => {
                    ToastHelper.showError('Có lỗi xảy ra');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* doi tuong */}
                <div className="col-6 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Đối tượng', true)}
                        <KTBSDropdown
                            toggleElement={({ showError }) => (
                                <button
                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''} dropdown-disabled`}
                                    type="button"
                                >
                                    {selectedObject ? t(`object_${selectedObject}`) : 'Chọn đối tượng'}
                                </button>
                            )}
                            selectedValue={selectedObject}
                            dropdownMenuItems={ChargeHelper.Data.tutorialObjectOptions}
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            dropdownMenuClassName="overflow-auto w-100"
                            onChange={(value) => setSelectedObject(value)}
                            enableCheckValid={readyToValidate}
                            isTouched={readyToValidate}
                            isValid={Utils.isValid(selectedObject)}
                            isDropdownForm={true}
                            feedbackText={!Utils.isValid(selectedObject)
                                ? 'Vui lòng chọn đối tượng'
                                : ''}
                            disabled={true}
                        />
                    </div>
                </div>
                {/* so thu tu */}
                <div className="col-6 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Thứ tự xuất hiện', true)}
                        <KTFormInput
                            type={KTFormInputType.number}
                            placeholder="Nhập số thứ tự"
                            name="order"
                            value={order}
                            onChange={(value) => {
                                const cleaned = value.replace(/[^\d]/g, '');
                                setOrder(cleaned);
                            }}
                            enableCheckValid={readyToValidate}
                            isValid={Utils.isValid(order) && Number(order) > 0}
                            isTouched={readyToValidate}
                            feedbackText={
                                !Utils.isValid(order) || Number(order) <= 0
                                    ? 'Số thứ tự không hợp lệ'
                                    : ''
                            }
                        />
                    </div>
                </div>
                {/* tieu de */}
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Tiêu đề', true)}
                        <KTFormInput
                            type={KTFormInputType.text}
                            placeholder="Nhập tiêu đề"
                            name="title"
                            value={title}
                            onChange={(value) => {
                                setTitle(value);
                            }}
                            enableCheckValid={readyToValidate}
                            isValid={
                                Utils.isValid(title)
                            }
                            isTouched={readyToValidate}
                            feedbackText={
                                !Utils.isValid(title)
                                    ? 'Vui lòng nhập tiêu đề'
                                    : ''
                            }
                        />
                    </div>
                </div>
                {/* file */}
                <div className="col-6 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Tải lên tập tin video', true)}
                        <KTVideoInput
                            fullWidth={true}
                            aspectRatio={'1'}
                            name={"video"}
                            editable={true}
                            value={!!selectedVideo && Utils.getFullUrl(selectedVideo)}
                            acceptVideoTypes={[
                                'video/mp4',
                                'video/quicktime',
                                'video/x-msvideo',
                                'video/x-ms-wmv',
                                'video/x-flv',
                                'video/x-matroska',
                                'video/webm'
                            ]}

                            enableCheckValid
                            onSelectedFile={(file) => {
                                setVideoSrc(file);
                                const video = URL.createObjectURL(file);
                                setSelectedVideo(video);
                            }}
                            onRemovedFile={() => {
                                setVideoSrc(null);
                                setSelectedVideo(null);
                            }}
                        />
                    </div>
                </div>
                {/* content */}
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Nội dung', true)}
                        <KTFormRichTextEditor
                            name={'content'}
                            data={content}
                            onChange={(value) => {
                                setContent(value);
                            }}
                        />
                    </div>
                </div>
            </div>
            {/* footer */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    !editMode ? 'Thêm' : 'Cập nhật',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogAddTutorialView;
